(() => {
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const CONCIERGE_NATIVE_STYLE_ID = 'hce-concierge-native-style';

  const prioritizeAvailableProducts = () => {
    const url = new URL(window.location.href);
    if (url.searchParams.has('sort_by')) return;

    document.querySelectorAll('#product-grid').forEach((grid) => {
      if (grid.querySelector('.collection_grid_inline_image')) return;
      const products = Array.from(grid.children).filter((item) => item.matches('[data-hce-available]'));
      if (products.length < 2) return;
      const available = products.filter((item) => item.dataset.hceAvailable === 'true');
      const soldOut = products.filter((item) => item.dataset.hceAvailable !== 'true');
      [...available, ...soldOut].forEach((item) => grid.appendChild(item));
    });
  };

  const initStockPriorityObserver = () => {
    let timer;
    const observer = new MutationObserver((mutations) => {
      const gridChanged = mutations.some((mutation) =>
        Array.from(mutation.addedNodes || []).some((node) =>
          node.nodeType === 1 && (node.id === 'ProductGridContainer' || node.querySelector?.('#ProductGridContainer'))
        )
      );
      if (!gridChanged) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(prioritizeAvailableProducts, 40);
    });
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  };

  const preserveFiltersOnExpand = () => {
    document.querySelectorAll('[data-hce-expand-all]').forEach((link) => {
      const target = new URL(link.getAttribute('href'), window.location.origin);
      const current = new URL(window.location.href);
      current.searchParams.forEach((value, key) => {
        if (key === 'page' || key === 'find') return;
        target.searchParams.append(key, value);
      });
      link.href = target.pathname + (target.searchParams.toString() ? `?${target.searchParams.toString()}` : '');
    });
  };

  const installConciergeNativeStyles = () => {
    if (document.getElementById(CONCIERGE_NATIVE_STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = CONCIERGE_NATIVE_STYLE_ID;
    style.textContent = `
      /* Concierge owns the filtering UI. Keep only a compact sort control below it. */
      body.hce-concierge-active #main-collection-filters .hce-native-filter-fallback,
      body.hce-concierge-active #main-collection-filters .hce-inline-grid,
      body.hce-concierge-active #main-collection-filters .hce-inline-toolbar > span,
      body.hce-concierge-active #main-collection-filters .hce-inline-toolbar [data-hce-inline-clear] {
        display: none !important;
      }

      body.hce-concierge-active #main-collection-filters {
        display: block !important;
        width: 100% !important;
      }

      body.hce-concierge-active #main-collection-filters .hce-inline-filters {
        display: block !important;
        width: 100% !important;
      }

      body.hce-concierge-active #main-collection-filters .hce-inline-toolbar {
        display: flex !important;
        justify-content: flex-end !important;
        align-items: center !important;
        width: 100% !important;
        padding: 14px 0 10px !important;
      }

      body.hce-concierge-active #main-collection-filters .hce-inline-sort {
        width: auto !important;
        margin-left: auto !important;
      }

      @media (max-width: 749px) {
        body.hce-concierge-active #main-collection-filters .hce-inline-toolbar {
          padding-top: 12px !important;
        }

        body.hce-concierge-active #main-collection-filters .hce-inline-sort {
          width: 100% !important;
          justify-content: space-between !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const initConcierge = () => {
    const concierge = document.querySelector('[data-hce-concierge]');
    if (!concierge || concierge.dataset.hceReady === 'true') return;

    const currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.get('find') !== '1') return;

    concierge.dataset.hceReady = 'true';
    concierge.hidden = false;
    concierge.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hce-concierge-active');
    installConciergeNativeStyles();

    const form = concierge.querySelector('[data-hce-concierge-form]');
    const countEl = concierge.querySelector('[data-hce-concierge-count]');
    const price = concierge.querySelector('[data-hce-price-input]');
    let refreshTimer;
    let requestController;

    // Concierge availability is based on every storefront-published cigar,
    // including sold-out products. In-stock cigars are still prioritised below.
    $$('[data-hce-stock-filter]', form).forEach((input) => input.remove());

    const formatConciergeMoney = (value) => {
      const amount = Number(value || 0);
      const locale = document.documentElement.lang || navigator.language || 'en-GB';
      const currency = window.Shopify?.currency?.active || '';
      if (currency) {
        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            currencyDisplay: 'narrowSymbol',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(amount);
        } catch (error) {}
      }
      const symbol = concierge.dataset.currencySymbol || '£';
      return `${symbol}${amount.toLocaleString(locale, { maximumFractionDigits: 0 })}`;
    };

    const updatePriceDisplay = () => {
      if (!price) return;
      const rawValue = String(price.value || '').trim();
      const formatted = rawValue === '' ? '' : formatConciergeMoney(rawValue);
      $('[data-hce-price-display]', concierge).forEach((el) => {
        el.textContent = formatted;
        el.hidden = rawValue === '';
      });
    };

    const normalizePriceHeading = () => {
      if (!price) return;
      const group = price.closest('[data-hce-filter-group]');
      const heading = group?.querySelector('summary > span:first-child');
      if (heading) heading.textContent = concierge.dataset.hcePriceHeadingLabel || 'Maximum Price';
    };

    const updateGroupMeta = () => {
      $$('[data-hce-filter-group]', concierge).forEach((group) => {
        const meta = group.querySelector('[data-hce-filter-meta]');
        if (!meta || group.contains(price)) return;
        const selected = $$('input[type="checkbox"]:checked', group);
        meta.textContent = selected.length ? String(selected.length) : '';
      });
    };

    const setOptionAvailability = (input, source) => {
      const label = input.closest('.hce-concierge-option');

      // A selected option must always remain enabled so the customer can remove it.
      // For all other options, Shopify's freshly calculated facet state is authoritative.
      if (!source) {
        if (!input.checked) {
          input.disabled = true;
          label?.classList.add('is-disabled');
          label?.setAttribute('aria-disabled', 'true');
        }
        return;
      }

      input.checked = source.checked;
      const disabled = source.disabled && !source.checked;
      input.disabled = disabled;
      label?.classList.toggle('is-disabled', disabled);
      if (disabled) label?.setAttribute('aria-disabled', 'true');
      else label?.removeAttribute('aria-disabled');
    };

    const syncConciergeAvailability = (doc) => {
      const incomingForm = doc.querySelector('[data-hce-concierge-form]');
      if (!incomingForm || !form) return;

      const incomingCheckboxes = $$('input[type="checkbox"]', incomingForm);
      const byKey = new Map(
        incomingCheckboxes.map((input) => [`${input.name}\u0000${input.value}`, input])
      );

      $$('input[type="checkbox"]', form).forEach((input) => {
        const source = byKey.get(`${input.name}\u0000${input.value}`);
        setOptionAvailability(input, source);
      });

      // Keep the visible count badges in step with the newly-calculated facet state.
      updateGroupMeta();
    };

    const buildTargetUrl = () => {
      const target = new URL(form?.getAttribute('action') || window.location.pathname, window.location.origin);
      const current = new URL(window.location.href);
      target.searchParams.set('find', '1');

      const sortBy = current.searchParams.get('sort_by');
      if (sortBy) target.searchParams.set('sort_by', sortBy);

      if (!form) return target;

      const data = new FormData(form);
      data.forEach((value, key) => {
        if (String(value).trim() === '') return;
        if (price && key === price.name && Number(value) >= Number(price.dataset.hcePriceMax || price.max)) return;
        target.searchParams.append(key, value);
      });
      return target;
    };

    const refreshProducts = async ({ immediate = false } = {}) => {
      if (!form) return;
      window.clearTimeout(refreshTimer);

      const run = async () => {
        const target = buildTargetUrl();
        try {
          requestController?.abort();
          requestController = new AbortController();
          document.body.classList.add('hce-finder-loading');

          const response = await fetch(target.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: requestController.signal
          });
          if (!response.ok) return;

          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');

          // Shopify has now recalculated every facet against the active selection.
          // Mirror those zero-result states back into the upper Concierge controls.
          syncConciergeAvailability(doc);

          const incomingFilters = doc.querySelector('#main-collection-filters');
          const currentFilters = document.querySelector('#main-collection-filters');
          if (incomingFilters && currentFilters) currentFilters.replaceWith(incomingFilters);

          const incomingGrid = doc.querySelector('#ProductGridContainer');
          const currentGrid = document.querySelector('#ProductGridContainer');
          if (incomingGrid && currentGrid) {
            currentGrid.replaceWith(incomingGrid);
            prioritizeAvailableProducts();
          }

          const marker = doc.querySelector('[data-hce-result-count]');
          if (marker && countEl) countEl.textContent = marker.dataset.hceResultCount || '0';

          window.history.replaceState({}, '', target.pathname + `?${target.searchParams.toString()}`);
          preserveFiltersOnExpand();
        } catch (error) {
          if (error?.name !== 'AbortError') console.warn('Cigar Concierge refresh failed', error);
        } finally {
          document.body.classList.remove('hce-finder-loading');
        }
      };

      if (immediate) return run();
      refreshTimer = window.setTimeout(run, 220);
    };

    $$('[data-hce-filter-group]', concierge).forEach((group) => {
      group.addEventListener('toggle', () => {
        if (!group.open) return;
        $$('[data-hce-filter-group]', concierge).forEach((other) => {
          if (other !== group) other.removeAttribute('open');
        });
      });
    });

    concierge.querySelector('[data-hce-brand-more]')?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const button = event.currentTarget;
      const panel = concierge.querySelector('[data-hce-brand-all]');
      if (!panel) return;
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
    });

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      refreshProducts({ immediate: true });
    });

    form?.addEventListener('change', (event) => {
      if (event.target.matches('[data-hce-price-input]')) updatePriceDisplay();
      updateGroupMeta();
      refreshProducts();
    });

    form?.addEventListener('input', (event) => {
      if (!event.target.matches('[data-hce-price-input]')) return;
      updatePriceDisplay();
      refreshProducts();
    });


    normalizePriceHeading();
    updatePriceDisplay();
    updateGroupMeta();
    refreshProducts({ immediate: true });
  };

  document.addEventListener('DOMContentLoaded', () => {
    preserveFiltersOnExpand();
    prioritizeAvailableProducts();
    initStockPriorityObserver();
    initConcierge();
  });

  document.addEventListener('shopify:section:load', () => {
    preserveFiltersOnExpand();
    initConcierge();
  });
})();

(() => {
  const hceI18n = window.hceI18n || {};
  const STYLE_ID = 'hce-maximum-price-style';
  let observerTimer;

  const escapeHtml = (value = '') => String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const installStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .hce-max-price { display:block; width:100%; padding:1.1rem 0 1.5rem; }
      .hce-max-price__value { margin:0 0 1.5rem; font-size:1.5rem; line-height:1.35; color:#1d1d1b; }
      .hce-max-price__value strong { font-weight:500; }
      .hce-max-price__range { --hce-price-progress:100%; -webkit-appearance:none !important; appearance:none !important; display:block; width:calc(100% - 18px); height:24px; margin:0 9px; padding:0; border:0; background:transparent !important; opacity:1 !important; cursor:pointer; }
      .hce-max-price__range:focus { outline:none; box-shadow:none; }
      .hce-max-price__range::-webkit-slider-runnable-track { width:100%; height:3px; border:0; border-radius:999px; background:linear-gradient(to right, #1d1d1b 0%, #1d1d1b var(--hce-price-progress), #c8c8c8 var(--hce-price-progress), #c8c8c8 100%); }
      .hce-max-price__range::-webkit-slider-thumb { -webkit-appearance:none !important; appearance:none !important; width:18px; height:18px; margin-top:-7.5px; border:0; border-radius:50%; background:#1d1d1b; box-shadow:none; cursor:grab; }
      .hce-max-price__range:active::-webkit-slider-thumb { cursor:grabbing; }
      .hce-max-price__range::-moz-range-track { width:100%; height:3px; border:0; border-radius:999px; background:#c8c8c8; }
      .hce-max-price__range::-moz-range-progress { height:3px; border-radius:999px; background:#1d1d1b; }
      .hce-max-price__range::-moz-range-thumb { width:18px; height:18px; border:0; border-radius:50%; background:#1d1d1b; box-shadow:none; cursor:grab; }
      .hce-max-price__ends { display:flex; justify-content:space-between; gap:1rem; margin-top:.7rem; font-size:1.2rem; line-height:1.3; color:#555; }
      @media screen and (max-width:749px) {
        .hce-max-price { padding:1rem 0 1.4rem; }
        .hce-max-price__value { font-size:1.4rem; }
      }
    `;
    document.head.appendChild(style);
  };

  const parseNumber = (value, fallback = 0) => {
    const parsed = Number(String(value ?? '').replace(/[^0-9.-]/g, ''));
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const normalizeCurrencySymbol = (value = '') => {
    const text = String(value).trim();
    const matched = text.match(/[£$€¥]/);
    return matched ? matched[0] : (text.replace(/[()]/g, '').trim() || '£');
  };

  const getCurrencyCode = () => window.Shopify?.currency?.active || '';

  const formatMoney = (value, fallbackSymbol) => {
    const number = parseNumber(value, 0);
    const locale = document.documentElement.lang || navigator.language || 'en-GB';
    const currency = getCurrencyCode();

    if (currency) {
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(number);
      } catch (error) {}
    }

    return `${fallbackSymbol}${number.toLocaleString(locale, { maximumFractionDigits: 0 })}`;
  };

  const ensurePriceHeading = (range) => {
    const container = range.closest('details, .filter-drawer-category-group, .mobile-facets__details');
    if (!container) return;
    const candidates = container.querySelectorAll('.facets__summary span, .filter-drawer-category-heading, .mobile-facets__summary span, summary span');
    for (const candidate of candidates) {
      const text = (candidate.textContent || '').trim().toLowerCase();
      const priceLabels = [
        'price',
        'maximum price',
        String(hceI18n.price || '').trim().toLowerCase(),
        String(hceI18n.maximumPrice || '').trim().toLowerCase()
      ];
      if (priceLabels.includes(text)) {
        candidate.textContent = hceI18n.price || 'Price';
        break;
      }
    }
  };

  const enhanceRange = (range) => {
    if (!range || range.dataset.hceMaxPriceReady === 'true') return;

    const numericInputs = Array.from(range.querySelectorAll('input[type="number"]'));
    const minInput =
      numericInputs.find((input) => /-GTE$/i.test(input.id || '')) ||
      numericInputs.find((input) => /\.gte$/i.test(input.name || '') || /\[gte\]/i.test(input.name || '')) ||
      numericInputs[0];

    const maxInput =
      numericInputs.find((input) => /-LTE$/i.test(input.id || '')) ||
      numericInputs.find((input) => /\.lte$/i.test(input.name || '') || /\[lte\]/i.test(input.name || '')) ||
      numericInputs[1];

    if (!maxInput?.name) return;

    const absoluteMax = Math.max(1, parseNumber(maxInput.getAttribute('max') || maxInput.placeholder || maxInput.value, 1));
    const rawCurrent = maxInput.value === '' ? absoluteMax : parseNumber(maxInput.value, absoluteMax);
    const current = Math.min(absoluteMax, Math.max(0, rawCurrent));
    const active = maxInput.value !== '' && current < absoluteMax;
    const symbol = normalizeCurrencySymbol(range.querySelector('.field-currency')?.textContent || '£');
    const minParamName = minInput?.name || '';
    const maxParamName = maxInput.name;

    range.dataset.hceMaxPriceReady = 'true';
    ensurePriceHeading(range);

    if (minParamName) {
      const url = new URL(window.location.href);
      if (url.searchParams.has(minParamName)) {
        url.searchParams.delete(minParamName);
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      }
    }

    range.innerHTML = `
      <div class="hce-max-price">
        <input class="hce-max-price__param" type="hidden" name="${escapeHtml(maxParamName)}" value="${current}" ${active ? '' : 'disabled'}>
        <p class="hce-max-price__value">${escapeHtml(hceI18n.upTo || 'Up to')} <strong data-hce-max-price-value>${escapeHtml(formatMoney(current, symbol))}</strong></p>
        <input
          class="hce-max-price__range"
          type="range"
          min="0"
          max="${absoluteMax}"
          step="1"
          value="${current}"
          aria-label="${escapeHtml(hceI18n.maximumPrice || 'Maximum price')}"
          aria-valuemin="0"
          aria-valuemax="${absoluteMax}"
          aria-valuenow="${current}"
        >
        <div class="hce-max-price__ends" aria-hidden="true">
          <span>${escapeHtml(formatMoney(0, symbol))}</span>
          <span>${escapeHtml(formatMoney(absoluteMax, symbol))}</span>
        </div>
      </div>
    `;

    const slider = range.querySelector('.hce-max-price__range');
    const hidden = range.querySelector('.hce-max-price__param');
    const valueEl = range.querySelector('[data-hce-max-price-value]');
    if (!slider || !hidden || !valueEl) return;

    const sync = () => {
      const value = Math.min(absoluteMax, Math.max(0, parseNumber(slider.value, absoluteMax)));
      hidden.value = String(value);
      hidden.disabled = value >= absoluteMax;
      valueEl.textContent = formatMoney(value, symbol);
      slider.setAttribute('aria-valuenow', String(value));
      slider.style.setProperty('--hce-price-progress', `${absoluteMax > 0 ? (value / absoluteMax) * 100 : 100}%`);
    };

    slider.addEventListener('input', sync);
    slider.addEventListener('change', sync);
    sync();
  };

  const enhanceMaximumPrice = (root = document) => {
    installStyles();
    const ranges = [];
    if (root.nodeType === 1 && root.matches?.('price-range.facets__price')) ranges.push(root);
    root.querySelectorAll?.('price-range.facets__price').forEach((range) => ranges.push(range));
    ranges.forEach(enhanceRange);
  };

  const initObserver = () => {
    if (!document.body) return;
    const observer = new MutationObserver((mutations) => {
      if (!mutations.some((mutation) => Array.from(mutation.addedNodes || []).some((node) => node.nodeType === 1))) return;
      window.clearTimeout(observerTimer);
      observerTimer = window.setTimeout(() => enhanceMaximumPrice(document), 30);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  document.addEventListener('DOMContentLoaded', () => {
    enhanceMaximumPrice(document);
    initObserver();
  });

  document.addEventListener('shopify:section:load', (event) => {
    enhanceMaximumPrice(event.target || document);
  });
})();


